export class City {
	country: string = '';
	name: string = '';
	_id: string = '';
}
